import React, {Component} from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'
import apiBarcode from "../../../services/api/apiBarcode"
import className from "classnames"

class MarkWrongDesignModal extends Component {
    state = {
        note: '',
        error: '',
        validated: false,
        loading: false
    }

    _handleChange = (e) => {
        const {name, value} = e.target

        this.setState({
            validated: false,
            error: '',
            [name]: value
        })
    }

    _markWrongDesign = async () => {
        const {note} = this.state

        this.setState({
            validated: true
        })

        if(note) {
            if (window.confirm("Bạn có chắc chắn muốn đánh dấu sai design?")) {
                try {
                    const {id, onClose} = this.props
                    const codes = id.split('_')

                    this.setState({
                        loading: true,
                        error: '',
                    })

                    const {data: respons} = await apiBarcode.markWrongDesign(codes[0], codes[1], {note})
                    const {success, message} = respons

                    if(!success) {
                        return this.setState({
                            loading: false,
                            error: message
                        })
                    }

                    this.setState({
                        loading: false
                    }, () => {
                        onClose()
                    })
                } catch (e) {
                    this.setState({
                        error: e.message,
                        loading: false,
                    })
                }
            }
        }
    }

    render() {
        const {isOpen, onClose} = this.props
        const {loading, error, note, validated} = this.state

        return (
            <div className="ModalEditStatus">
                <Modal isOpen={isOpen} toggle={onClose}>
                    <ModalHeader toggle={onClose}>Đánh dấu sai dessign </ModalHeader>
                    <ModalBody>
                        <div className="note row">
                            <label className="col-sm-12 col-form-label">Chú thích</label>
                            <div className="col-sm-12">
                                <textarea rows={5} className={className('form-control', (note === '' && validated) && 'border-danger')} name="note" onChange={this._handleChange}/>
                                {(note === '' && validated) && (
                                    <div className="text-danger mt-1">Vui lòng nhập chú thích</div>
                                )}
                            </div>
                        </div>
                        {
                            error && (
                                <div className="text-danger mt-1">{error}</div>
                            )
                        }
                    </ModalBody>
                    <ModalFooter className="d-flex justify-content-between">
                        <button className="btn btn-secondary" color="secondary" onClick={onClose}>Hủy</button>
                        <button disabled={loading} onClick={this._markWrongDesign} className="btn btn-primary">
                            Đánh dấu sai design
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

}

export default MarkWrongDesignModal
